import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "../context/AppContext";

const TopDoctors = () => {
  const navigator = useNavigate();
  const { doctors } = useContext(AppContext);
  return (
    <div className="flex flex-col items-center my-16 gap-4 text-gray-900 md:mx-10">
      <h1 className="text-3xl font-medium "> top doctors</h1>
      <p className="text-center text-sm sm:w-1/3">
        Lorem ipsum dolor sit amet consectetur adipisicing elit.
      </p>
      <div className="w-full grid grid-cols-auto gap-4 pt-5 px-3 sm:px-0 ">
        {doctors.slice(0, 10).map((ele, index) => (
          <div
            className=" border border-blue-200 rounded-xl cursor-pointer"
            key={index}
            onClick={() => navigator(`/appointment/${ele._id}`)}
          >
            <img className="bg-blue-50" src={ele.image} alt="ele" />
            <div className="p-2">
              <div className="flex gap-1 items-center mt-2">
                <p className="h-3 bg-green-500 rounded-full w-3 "></p>{" "}
                <p>Available</p>
              </div>
              <p className="text-lg font-medium text-gray-900">{ele.name}</p>
              <p className="text-sm text-gray-500 ">{ele.speciality}</p>
            </div>
          </div>
        ))}
      </div>
      <button
        onClick={() => navigator("/doctors")}
        className="px-7 py-3 bg-gray-300 rounded-full"
      >
        more...
      </button>
    </div>
  );
};

export default TopDoctors;
